export const data = {
  search: {
    en: {
      "已筛选": "Screen",
      "筛选": "screened",
      "商品": "products",
      "大家都在买": "Recommended Goods",
      "进去瞧瞧": "More",
      '您输入的搜词过长': 'Search term too long'
    },
    cn: {
      '大家都在买': '大家都在买',
      '进去瞧瞧': '进去瞧瞧',
      '您输入的搜词过长': '您输入的搜词过长'
    }

  },
  address: {
    en: {
      '配送至': "Deliver to",
      '配送区域': "Delivery area",
      '选择城市': "Pls select city",
      '请输入城市名称': "Pls Input city name",
      '定位城市': "Locate city",
      '定位失败，请稍后再尝试': "Fail to locate, pls try again later",
      '定位失败': "Fail to locate",
      '最近访问城市': "Latest visited city",
      '热门城市': "Popular city",
      '热': "Hot",
      '使用定位': "Use location",
      '刷新位置': "Refresh address",
      '使用收货地址': "Use delivery address",
      '暂无收货地址': "No delivery address",
      '配送至其他地址': "Deliver to other address",
      '其他配送区域': "Deliver for other areas",
      '请选择': "Pls select",
      '配送地址': "Shipping address",
      '不可配送': "Unavailable",
      '抢光了': "Sellout",
      '补货中': "Replenishing",
    },
    cn: {}
  },
  quick: {
    en: {
      "请输入搜索关键词": "Pls input search keyword",
      "搜索": "Search",
      "最近搜过": "Latest search",
      "没有找到相关商品哦": "No relevant commodities found",
      "免费": "Free",
    },
    cn: {
      "请输入搜索关键词": "请输入搜索关键词",
      "搜索": "搜索",
      "最近搜过": "最近搜过",
      "福豆": "福豆",
      "没有找到相关商品哦": "没有找到相关商品哦",
      "免费": "免费",
    },
  },
  result: {
    en: {
      "年": "-",
      "月": "-",
      "日": " ",
      "号": " ",
      "时": ":",
      "分": ":",
      "秒": " ",
      "sorry1": "Sorry, no “ ",
      "sorry2": " ” relavant products found“",
      "抱歉，没有找到相关商品": "Sorry, no relevant commodities found",
      "请修改条件重新查询": "Try to change keyword～",
      "为你推荐": "Recommendations for you",
      "起发货": "Delivery from",
      "全部":"All",
      "节日礼包": "Festival gift bag",
      "蛋糕": "Cake",
      "景点": "Scenic spots",
      "玩乐": "Recreation",
      "电子券": "e-coupon",
      "影院": "Cinema",
      "影片": "Film",
      "演出": "Performance",
      "体检套餐": "ME package",
      "体检机构": "ME agency",
      "健康商城": "Health mall",
      "运动健身": "Fitness",
      "口腔健康": "Mouth health",
      "美食汇": "Offline merchant",
      "线下商户": "Offline merchant",
      "东福超市": "DF market",
      "优选生活": "Preferred life",
      "图书": "Books",
      "京东优选": "JD preference",
      "小米有品": "MI selection",
      "网易严选": "Lifease",
      "酒店": "Hotel",
      "随心兑": "Go-as-you-please exchange",
      "扫一扫":"Scan",
      "听书": "listen",
      "一企学": "MOOC",
      "健康服务": "Health service",
      "综合": "Overall",
      "综合排序": "Comprehensive ranking",
      "综合推荐": "Comprehensive recommendation",
      "新品优先": "New arrival first",
      "销量由高到低": "Sales volume from high to low",
      "热度优先": "Popularity first",
      "销量": "Sales volume",
      "新品": "New arrival",
      "热度": "Popularity",
      "价格升序": "Price ascending",
      "价格降序": "Price descending",
      "距离 近到远": "Distance from near to far",
      "好评优先": "Praise first",
      "低价优先": "Low price first",
      "高价优先": "High price first",
      "距离": "Distance",
      "好评": "Praise",
      "低价": "Low price",
      "高价": "High price",
      "仅看有货": "Only view available",
      "分类": "Classification",
      "品牌": "Brand",
      "价格": "Price",
      "城市": "City",
      "时间": "Time",
      "票价": "Fares",
      "目的地": "Destination",
      "出发地": "Departure",
      "区域": "Region",
      "主题": "Theme",
      "医院类别": "Hospital category",
      "性别": "Gender",
      "筛选": "Screen",
      "入住": "Check-in",
      "离店": "Checkout",
      "选择日期": "Select date",
      "最低价": "Minimum rate",
      "最高价": "Maximum rate",
      "重置": "Re-set",
      "确定": "Confirm",
      "起": "Starting",
      "入离日期": "Check-in/checkout date",
      "位置": "location",
      "行政区": "Administrative district",
      "商圈": "Business district",
      "星级": "Star level",
      "豪华/五星": "Luxury/five stars",
      "高档/四星": "Upscale/four stars",
      "舒适/三星": "Comfort/three starts",
      "经济型": "Economy hotel",
      "房型": "Room type",
      "床型": "Room type",
      "大床间（单间）": "Double bed room (single room)",
      "单人间（单间）": "Single bed room (single room)",
      "双床间（单间）": "Twin room (single room)",
      "三人间（单间）": "Triple room (single room)",
      "套房": "Suite",
      "独栋": "Detached house",
      "床位房": "Bed",
      "酒店类型": "Hotel type",
      "score": "Score", // 评分
      "靠近": "Near ",
      "导演": "Director",
      "主演": "Protagonist",
      "findJIGOU": "Find GGG relevant agencies for you",
      "otherAll": "Total RRR result(s)",
      "更多": "More",
      "专享价": "Special price",
      "约":"About ",
      "约个门店": "About XXX merchant(s)",
      "约个商品": "About XXX product(s)",
      "我是有底线的": "End",
      "加载中": "Loading...",
      '没有更多了':'No more',
      '加载失败': "Fail to load. Pull up to reload",
      "正在加载": "Loading",
      "supportJIGOU": "Provided by SSS agency(ies)",
      "supportNum": "Provided by NNN",
      "一周内": "Within one week",
      "一个月内": "Within one month",
      "三个月内": "Within three months",
      "搜索关键字不能为空": "Search keyword shall not be vacant!",

      "距离优先": "Distance first",
      "价格优先": "Price first",
      "价格筛选": "Price screening",
      "附近": "Nearby",
      "距您直线{1}": "{1} away from you",
    },
    cn: {
      "年": "年",
      "月": "月",
      "日": "日",
      "号": "号",
      "时": "时",
      "分": "分",
      "秒": "秒",
      "sorry1": "抱歉, 没有找到与“",
      "sorry2": "”符合条件的内容",
      "抱歉，没有找到相关商品": "抱歉，没有找到相关商品～",
      "请修改条件重新查询": "请修改条件重新查询",
      "为你推荐": "为你推荐",
      "起发货": "起发货",
      "全部":"全部",
      "节日礼包": "节日礼包",
      "蛋糕": "蛋糕",
      "景点": "景点",
      "玩乐": "玩乐",
      "电子券": "电子券",
      "影院": "影院",
      "影片": "影片",
      "演出": "演出",
      "体检套餐": "体检套餐",
      "体检机构": "体检机构",
      "健康商城": "健康商城",
      "运动健身": "运动健身",
      "口腔健康": "口腔健康",
      "美食汇": "美食汇",
      "线下商户": "美食汇",
      "东福超市": "东福超市",
      "优选生活": "优选生活",
      "图书": "图书",
      "京东优选": "京东优选",
      "小米有品": "小米有品",
      "网易严选": "网易严选",
      "酒店": "酒店",
      "随心兑": "随心兑",
      "扫一扫": "扫一扫",
      "健康服务": "健康服务",
      "综合": "综合",
      "综合排序": "综合排序",
      "综合推荐": "综合推荐",
      "新品优先": "新品优先",
      "销量由高到低": "销量由高到低",
      "热度优先": "热度优先",
      "销量": "销量",
      "新品": "新品",
      "热度": "热度",
      "价格升序": "价格升序",
      "价格降序": "价格降序",
      "距离 近到远": "距离 近到远",
      "好评优先": "好评优先",
      "低价优先": "低价优先",
      "高价优先": "高价优先",
      "距离": "距离",
      "好评": "好评",
      "低价": "低价",
      "高价": "高价",
      "仅看有货": "仅看有货",
      "分类": "分类",
      "品牌": "品牌",
      "价格": "价格",
      "城市": "城市",
      "时间": "时间",
      "票价": "票价",
      "目的地": "目的地",
      "出发地": "出发地",
      "区域": "区域",
      "主题": "主题",
      "医院类别": "医院类别",
      "性别": "性别",
      "筛选": "筛选",
      "入住": "入住",
      "离店": "离店",
      "选择日期": "选择日期",
      "最低价": "最低价",
      "最高价": "最高价",
      "重置": "重置",
      "确定": "确定",
      "起": "起",
      "入离日期": "入离日期",
      "位置": "位置",
      "行政区": "行政区",
      "商圈": "商圈",
      "星级": "星级",
      "豪华/五星": "豪华/五星",
      "高档/四星": "高档/四星",
      "舒适/三星": "舒适/三星",
      "经济型": "经济型",
      "房型": "房型",
      "床型": "床型",
      "大床间（单间）": "大床间（单间）",
      "单人间（单间）": "单人间（单间）",
      "双床间（单间）": "双床间（单间）",
      "三人间（单间）": "三人间（单间）",
      "套房": "套房",
      "独栋": "独栋",
      "床位房": "床位房",
      "酒店类型": "酒店类型",
      "score": "分", // 评分
      "靠近": "靠近",
      "导演": "导演",
      "主演": "主演",
      "findJIGOU": "为您找到GGG个相关的体检机构",
      "otherAll": "其他共RRR个相关结果",
      "更多": "更多",
      "专享价": "专享价",
      "约":"约",
      "约个门店": "约XXX个门店",
      "约个商品": "约XXX个商品",
      "我是有底线的": "我是有底线的",
      "加载中": "加载中...",
      '没有更多了': "没有更多了",
      '加载失败': "加载失败，上拉重新加载",
      "正在加载": "正在加载",
      "supportJIGOU": "由SSS家机构提供",
      "supportNum": "由NNN提供",
      "一周内": "一周内",
      "一个月内": "一个月内",
      "三个月内": "三个月内",
      "搜索关键字不能为空": "搜索关键字不能为空!",

      "距离优先": "距离优先",
      "价格优先": "价格优先",
      "价格筛选": "价格筛选",
      "附近": "附近",
      "距您直线{1}": "距您直线{1}",
    },
  },
  sxChange: {
    en: {
      "随心兑": "easy exchange",
      "超市便利": "supermarket",
      "去兑换": "go to redeem",
      "到店": "visit a store",
      "扫一扫":"Scan",
      "美食汇": "offline",
      "线下商户": "offline",
      "折": "off",
      "最近门店": "Nearest shop",
      "到店消费任意金额可用": "Available for any in-store consumption",
      "到店消费": "Available for ",
      "可用": " in-store consumption",
      "任意金额": "any",
      "满": '￥',
      "元": " ",
      "需平台服务费": "Platform service fee is required",
    },
    cn: {
      "随心兑": "随心兑",
      "超市便利": "超市便利",
      "去兑换": "去兑换",
      "到店": "到店",
      "扫一扫":"扫一扫",
      "美食汇": "美食汇",
      "线下商户": "美食汇",
      "折": "折",
      "最近门店": "最近门店",
      "到店消费任意金额可用": "到店消费任意金额可用",
      "到店消费": "到店消费",
      "可用": "可用",
      "任意金额": "任意金额",
      "满": "满",
      "元": "元",
      "需平台服务费": "需平台服务费",
    }
  },
  cart: {
    en: {
      "已选": "Selected",
      "规格": "Specification",
      "数量": "Quantity",
      "加入购物车": "Add to shopping cart",
      "加入购物车成功": "Successful",
      "限购1": " ",
      "限购2": " limited",
      "起购1": "Min.",
      "起购2": " ",
      "预售": "Presale",
      "preSale": "Delivery from ",
      "preSale1": "Order now, delivery from ",
      "preSale2": " ",
      "特价": "Off-price",
      "抢购": "Flash",
      "新品": "New",
      "满减": "Cash back",
      "抽奖": "Lottery",
    },
    cn: {
      "已选": "已选",
      "规格": "规格",
      "数量": "数量",
      "加入购物车": "加入购物车",
      "加入购物车成功": "加入购物车成功",
      "限购1": "限购",
      "限购2": "件",
      "起购1": " ",
      "起购2": "件起购",
      "预售": "预售",
      "preSale": "现在下单,",
      "preSale1": "现在下单,",
      "preSale2": "起发货",
      "特价": "特价",
      "抢购": "抢购",
      "新品": "新品",
      "满减": "满减",
      "抽奖": "抽奖",
    }
  },
  card: {
    en: {
      "请输入短信验证码": "Please enter SMS verification code",
      "请设置4位支付密码": "Please Set 4-digit payment password",
      "请确认支付密码": "please confirm payment password",
      "请输入支付密码": "Please enter payment password",
      "setPwdTips": "No payment password set, please select settings",
      "重新输入": "Re-enter",
      "发送验证码": "Send Verification Code",
      "验证码已发送至": "Verification code has been sent to",
      "绑定福利卡": "Bind benefit card",
      "cardPWD": "Please enter 16-digit card password, not case sensitive",
      "cardPWD1": "Please enter 16-digit card password",
      "cardPWD2": "not case sensitive",
      "立即绑定": "Bind now",
      "扫码绑定": "Scan to bind",
      "可用次数": "Available times",
      "可用余额": "Available Balances",
      "次": "Times",
      "卡号": "Card No.",
      "有效期至": "Expiration date",
      "确认绑定": "Confirm bind",
      "确认绑定福利卡": "Confirm binding benefit card",
      "请输入正确的卡密": "Please enter correct card password",
      "绑定福利卡成功": "Successful",
      "抵扣": "Deduction",
      "请输入16位卡密码": "Pls input card password of 16 digits",
      "确认绑定这张福利卡吗": "Are you sure to bind this bonus card",
      "请输入四位数字支付密码": "Pls input password of 4 digits",
      "输入的密码4位数字不能相同或连续": "4-digit password cannot be same or continuous",
      "请再次输入四位数字支付密码": "Pls input password of 4 digits again",
      "checkPayPwd": "Password is inconsistent, please retype it",
      "暂无可用余额": "No balances available",
      "暂无可用积分": "No points available temporarily",
      "福豆": "FuDou",
      "无可用卡": "No available card",
      "cardlock": "Card locked, fail to bind",
      "cardexpire": "Expired coupon, fail to bind",
      "cardbind": "Sorry, the card has been bound",
      "可用积分": "Available Points",
      "点击筛选可用": "Click to screen ",
      "以下是可用": "Following is ",
      "福利卡": "deductible ",
      "抵扣的商品": "products ",
      "取消": "cancel",
      "可用福利卡抵扣的商品": "Deductible products with bonus card",
    },
    cn: {
      "请设置4位支付密码": "请设置4位支付密码",
      "请输入短信验证码": "请输入短信验证码",
      "重新输入": "重新输入",
      "请输入支付密码": "请输入支付密码",
      "请确认支付密码": "请确认支付密码",
      "setPwdTips": "No payment password set, please select settings",
      "验证码已发送至": "验证码已发送至",
      "发送验证码": "发送验证码",
      "绑定福利卡": "绑定福利卡",
      "cardPWD": "请输入16位卡密，卡密不区分大小写",
      "cardPWD1": "请输入16位卡密",
      "cardPWD2": "卡密不区分大小写",
      "立即绑定": "立即绑定",
      "扫码绑定": "扫码绑定",
      "可用次数": "可用次数",
      "可用余额": "可用余额",
      "次": "次",
      "卡号": "卡号",
      "有效期至": "有效期至",
      "确认绑定": "确认绑定",
      "确认绑定福利卡": "确认绑定福利卡",
      "请输入正确的卡密": "请输入正确的卡密",
      "绑定福利卡成功": "绑定福利卡成功",
      "抵扣": "抵扣",
      "请输入16位卡密码": "请输入16位卡密码",
      "确认绑定这张福利卡吗": "确认绑定这张福利卡吗",
      "请输入四位数字支付密码": "请输入四位数字支付密码",
      "checkPayPwd": "两次输入不一致,请重新输入",
      "暂无可用余额": "暂无可用余额",
      "暂无可用积分": "暂无可用积分",
      "无可用卡": "无可用卡",
      "福豆": "福豆",
      "cardlock": "卡已锁定，无法绑定",
      "cardexpire": "卡券已过期，无法绑定",
      "cardbind": "抱歉，该卡已被绑定",
      "可用积分": "可用积分",
      "点击筛选可用": "点击筛选可用",
      "以下是可用": "以下是可用",
      "福利卡": "福利卡",
      "抵扣的商品": "抵扣的商品",
      "取消": "取消",
      "可用福利卡抵扣的商品": "可用福利卡抵扣的商品",
    },
  },
  user: {
    en: {
      "自动扣款": "Auto deduction",
      "支付设置": "Payment settings",
    },
    cn: {
      "自动扣款": "自动扣款",
      "支付设置": "支付设置",
    },
  },
  distance: {
    en: {
      "不限": "Unlimited",
    },
    cn: {
      "不限": "不限",
    },
  },
  error: {
    en: {
      "Network Error": "You are operating too often. Please try again later."
    },
    cn: {
      "Network Error": "您操作频率过快，请稍后再试"
    }
  }
};
